export { default } from './toPairsIn.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/entriesIn.js
// module id = 630
// module chunks = 67